import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isEqual from 'lodash/isEqual';
import isNil from 'lodash/isNil';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import {INPUT_TYPES} from '../forms/enums/InputTypes';


export function getIsDirty(isChanging) {
  return Object
    .values(isChanging)
    .reduce((acc, isChanging) => isChanging || acc, false);
}

export function getResponseValue(field, model, prop, fieldIndex) {
  switch (field.type) {
    case INPUT_TYPES.date:
    case INPUT_TYPES.duration:
    case INPUT_TYPES.list:
    case INPUT_TYPES.scale: {
      const response = get(model, 'responses', [])[fieldIndex];
      return isNil(response) ? {} : response.result;
    }

    case INPUT_TYPES.text_long: {
      const response = get(model, 'responses', [])[fieldIndex];
      const value = get(response, 'result.value');
      return isNil(value) ? '' : value;
    }

    case INPUT_TYPES.text_short: {
      const response = get(model, 'responses', [])[fieldIndex];
      return getTextShortValue(get(response, 'result.value'), field.options.isNumber);
    }

    default:
      return null;
  }
}

export function getTextShortValue(value, number) {
  if (number) {
    return isNumber(value) ? value : 0;
  } else {
    return isString(value) ? value : '';
  }
}

export function valueIsEqual(field, prevValue, nextValue) {
  switch (field.type) {
    case INPUT_TYPES.text_long:
    case INPUT_TYPES.text_short:
      return prevValue === nextValue;

    case INPUT_TYPES.date:
    case INPUT_TYPES.duration:
    case INPUT_TYPES.scale:
      return isEqual(prevValue, nextValue);

    case INPUT_TYPES.list:
      if (get(field, 'options.selectMany')) {
        return deepCompareLists(prevValue, nextValue);

      } else {
        return deepCompareItem(prevValue, nextValue);

      }

    default:
      return prevValue !== nextValue;
  }
}

export function deepCompareLists(a, b) {
  if (a === b || (!a && !b)) {
    return true;
  } else if (!a || !b) {
    return false;
  } else if (!isArray(a) || !isArray(b)) {
    return false;
  } else if (a.length !== b.length) {
    return false;
  }

  const len = a.length;

  for (let i = a; i < len; i++) {
    if (!deepCompareItem(a[i], b[i])) {
      return false;
    }
  }

  return true;
}

export function deepCompareItem(a, b) {
  if (a === b || (!a && !b)) {
    return true;

  } else if (!a || !b) {
    return false;

  } else {
    return a.id === b.id && a.label === b.label;
  }
}



// WEBPACK FOOTER //
// ./src/js/form-builder/utils.js